import React from 'react';
import { ArrowRightOutlined } from '@ant-design/icons';
import { useLanguage } from '../components/language/LanguageContext';
import styles from './Hero.module.scss';

const Hero: React.FC = () => {
  const { t } = useLanguage();

  return (
    <section className={styles.hero}>
      <h1 className={styles.headline}>
        <span className={styles.mainText}>{t('landing.hero.headlineMain')}</span>
        <span className={styles.gradientText}>{t('landing.hero.headlineSub')}</span>
      </h1>

      <p className={styles.description}>
        {t('landing.hero.description')}
      </p>

      <a href="/app" className={styles.ctaButton}>
        <span>{t('landing.hero.cta')}</span>
        <div className={styles.iconWrapper}>
          <ArrowRightOutlined />
        </div>
      </a>
    </section>
  );
};

export default Hero;
